import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import { GetPlanInput, GetPoliciesInput } from '../../apiTypes';
import { typePolicies } from './types';

const policesQuery = (variables?: GetPoliciesInput): QueryInfos => {
    return {
        name: `policies-${JSON.stringify(variables)}`,
        path: `/policies`,
        type: typePolicies.GET_POLICIES,
        params: {
            ...variables,
            enrich_dispatch_groups: 1,
        },
    };
};

const policesPlanQuery = (variables?: GetPlanInput): QueryInfos => {
    const { uuid } = variables;
    return {
        name: `policies-plan-${uuid}`,
        path: `/policies/plans/${uuid}`,
        type: typePolicies.GET_PLAN,
        params: {},
    };
};

const policesSelfServiceQuery = (variables?: GetPoliciesInput): QueryInfos => {
    return {
        name: `policies-selfService-${JSON.stringify(variables)}`,
        path: `/policies/plans`,
        type: typePolicies.GET_POLICIES_SELFSERVICE,
        params: {
            ...variables,
            eligible_self_service: 1,
        },
    };
};

export function useGetPolicies<T>(options?: Options<GetPoliciesInput>): UseQueryResult<T, Error> {
    return useMyQuery<T>(policesQuery, {
        ...options,
    });
}

export function useGetPlan<T>(options?: Options<GetPlanInput>): UseQueryResult<T, Error> {
    return useMyQuery<T>(policesPlanQuery, {
        ...options,
    });
}

export function useGetPoliciesSelfService<T>(options?: Options<GetPoliciesInput>): UseQueryResult<T, Error> {
    return useMyQuery<T>(policesSelfServiceQuery, {
        ...options,
    });
}
